export default {"src":"/_next/static/media/icon-expand.8e796b61.svg","height":8,"width":14,"blurWidth":0,"blurHeight":0};